import { render, staticRenderFns } from "./ProcessVisit.vue?vue&type=template&id=45971d3a&scoped=true&"
import script from "./ProcessVisit.ts?vue&type=script&lang=ts&"
export * from "./ProcessVisit.ts?vue&type=script&lang=ts&"
import style0 from "./ProcessVisit.scss?vue&type=style&index=0&id=45971d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45971d3a",
  null
  
)

export default component.exports